import CrAnalysisService from 'app/services/CrAnalysisService';
import BaseAnalysisLoadPageMixin from 'app/mixins/BaseAnalysisLoadPageMixin';

export default {
  mixins: [ BaseAnalysisLoadPageMixin ],

  created() {
    this.service = CrAnalysisService;
    this.label = 'Analisi CR';
    this.analysisType = 'cr';
    this.findPage = 'CrAnalyses';
    this.editorComponent = 'cr-analysis';
  },
};
